import type { IndicatorType } from 'shared/types'
import { getIndicatorsColor } from '@/lib/utils'
import { circle } from '../shared'
import type { Radar } from 'shared'

export function Base(props: { radarOnSubSection?: boolean; indicators: Radar['indicators'] | undefined }) {
  const getColor = (ringType: IndicatorType, index: number) =>
    props.radarOnSubSection && props.indicators?.[ringType].some((elem) => elem.index === index)
      ? getIndicatorsColor(ringType, index).normal
      : getIndicatorsColor(ringType, index).lighter

  return (
    <>
      {circle.map((ring) =>
        ring.list.map((indicator, index) => (
          <path
            key={`${ring.type}-${indicator.slice(0, 20)}`}
            fill={getColor(ring.type, index)}
            stroke="var(--color-card)"
            strokeMiterlimit="10"
            d={indicator}
          />
        )),
      )}
    </>
  )
}
